// extracted by mini-css-extract-plugin
export default {"tagLogoWrapper":"tag_styles_tagLogoWrapper__bAaDp","addNewAppButtonWrapper":"tag_styles_addNewAppButtonWrapper__icz7g","loadMoreButton":"tag_styles_loadMoreButton__jyPkD"};